import TrackingService from '../services/trackingService';

export default function useTracking() {
  const trackingService = TrackingService.getInstance();

  const trackEvent = (eventName: string) => {
    trackingService.track(eventName);
  };

  const identifyUser = (userId: string) => {
    if (process.env.REACT_APP_USE_SKIP_TESTS === 'true') return;
    trackingService.identify(userId);
  };

  return {
    trackEvent,
    identifyUser,
  };
}
